<template>
    <div>
        <div class="layout-right bg mb16">
            <Form :label-width="110">
                <Row :gutter="24">
                    <Col span="8">
                        <Form-item label="批改单号">
                            <Input v-model.trim="params.billNo" clearable placeholder="请输入批改单号" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批改单状态">
                            <Select v-model="params.status" clearable>
                                <Option v-for="(item,index) in list" :value="item.value" :key="index">{{ item.label }}</Option>
                            </Select>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="险种">
                            <Input v-model.trim="params.insuranceName" clearable placeholder="请输入险种" @on-enter="tabChange"></Input>
                        </Form-item>
                    </Col>
                    <Col span="8">
                        <Form-item label="批改单创建时间">
                            <daterange @on-change="val=>{setDateRange(val,'createTime')}" placeholder="请选择创建时间" placement="bottom-end"></daterange>
                        </Form-item>
                    </Col>
                    <Col span="24" class="right">
                        <Button type="primary" @click="tabChange">搜索</Button>
                        <Button type="primary" @click="exportToExcel('/specialEquipment/insurance/export',params)">导出</Button>
                    </Col>
                </Row>
            </Form>
        </div>
        <div class="layout-right bg">
            <i-table :columns="columns" url="/specialEquipment/insurance/list.json" :params="params" ref="table">
                <template slot-scope="{ row }" slot="action">
                    <a @click="toDetail(row)">查看详情</a>
                </template>
            </i-table>
        </div>
    </div>
    </template>
    <script>
    import ITable from '@/components/common/ITable'
    import daterange from '@/components/common/daterange'
    export default {
        components:{ ITable,daterange },
        data () {
            return {
                loading: false,
                params: {
                    billType:'2'
                },
                columns: [
                    {title:'批改单号',key:'billNo',width: 260,fixed: 'left'},
                    {title:'险种',key:'insuranceName',minWidth: 180,ellipsis: true,tooltip: true},
                    {title:'批改单创建时间',key:'createTime',width: 180},
                    {title:'状态',key:'statusName',minWidth: 120},
                    {
                        title: '操作',
                        slot: 'action',
                        width: 100,
                        align: 'center',
                        fixed: 'right'
                    }
                ],
                list:[
                    {
                        value: '1',
                        label: '待审核'
                    },
                    {
                        value: '3',
                        label: '已拒保'
                    },
                    {
                        value: '4',
                        label: '已完成'
                    }
                ]
            }
        },
        computed:{
        },
        created () {
        },
        methods:{
            tabChange(){
                this.$refs.table.getList()
            },
            toDetail(row){
                this.$router.push({
                    path:`/my/customizedTPL/riderDetail/${row.billNo}`
                })
            },
            setDateRange (val,key) {
                this.params[key+"Begin"] = val[0];
                this.params[key+"End"] = val[1];
            }
        }
    };
</script>
<style lang="less" scoped>
    .policy{
		display:flex;
        flex-wrap: wrap;
	}
	.policy-item{
		margin-right: 15px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedForklift/rider/index.vue